import {getLanguageFromLS} from '@innowise-group/utilities';
import {GlobalContainerTypes, injectable, Languages} from '../..';
import {Language} from './language.types';
import {authenticationState} from '../authentication/authentication-state';

@injectable()
class LanguageService implements Language {
  public static readonly type = GlobalContainerTypes.Language;

  constructor() {
    this.getAppLanguage = this.getAppLanguage.bind(this);
    this.checkAppLanguage = this.checkAppLanguage.bind(this);
  }

  public getAppLanguage(): string {
    if (authenticationState.getIsLocal()) {
      return Languages.En;
    }
    return getLanguageFromLS();
  }

  public checkAppLanguage(): boolean {
    return this.getAppLanguage() === 'ru';
  }
}

export default LanguageService;
